export type Breakpoint = 'xl' | 'lg' | 'md' | 'sm' | 'xs' | '2xl';

export const breakpoints: Record<Breakpoint, number> = {
  xs: 360,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1920,
};
